@if (promiseTracker.isActive()) {
  @if (customTemplate) {
    <ng-container *ngTemplateOutlet="customTemplate"></ng-container>
  } @else {
    <spinner [position]="position"> </spinner>
  }
}
